export default "__VITE_ASSET__DiJsV_lJ__"